(() => {
  'use strict';
  if (window.feHormonalGift) return;
  const element = document.getElementById('fe-hormonal-gift-config');
  if (!element) return;
  const config = JSON.parse(element.textContent);
  const desired = config.variants[config.country] || config.variants.EN;
  const giftIds = new Set(Object.values(config.variants));
  const root = config.root.endsWith('/') ? config.root : config.root + '/';
  let pending = Promise.resolve();
  let publishing = false;
  let scheduled = false;
  let checkoutBusy = false;
  let replayForm = null;

  async function request(path, body) {
    const response = await fetch(root + path, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      signal: AbortSignal.timeout(15000),
      ...(body ? { body: JSON.stringify(body) } : {})
    });
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(data.description || 'Cart request failed');
    return data;
  }

  function plan(cart) {
    const gifts = cart.items.filter(item => giftIds.has(item.variant_id));
    const eligible = Boolean(desired) && cart.items.some(item => !giftIds.has(item.variant_id) && item.final_line_price > 0);
    const keep = eligible ? gifts.find(item => item.variant_id === desired) : null;
    const updates = {};
    for (const item of gifts) {
      const quantity = item === keep ? 1 : 0;
      if (item.quantity !== quantity) updates[item.key] = quantity;
    }
    return { updates, add: eligible && !keep ? desired : null };
  }

  function showError() {
    let notice = document.getElementById('fe-guide-error');
    if (!notice) {
      notice = document.createElement('div');
      notice.id = 'fe-guide-error';
      notice.setAttribute('role', 'alert');
      notice.style.cssText = 'position:fixed;bottom:16px;left:16px;right:16px;z-index:99999;background:#fff3ef;color:#722d26;padding:16px;border:1px solid #e09b8b;border-radius:8px';
      document.body.append(notice);
    }
    notice.textContent = config.error;
  }

  async function reconcile() {
    let cart = await request('cart.js');
    const changes = plan(cart);
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } }));
    const sectionIds = [...new Set(sections)].slice(0, 5);
    const renderOptions = { sections: sectionIds, sections_url: location.pathname };
    let changed = false;
    if (Object.keys(changes.updates).length) {
      cart = await request('cart/update.js', { updates: changes.updates, ...renderOptions });
      changed = true;
    }
    if (changes.add) {
      await request('cart/add.js', { items: [{ id: changes.add, quantity: 1, properties: { _fe_gift: 'hormonal-guide' } }] });
      cart = await request('cart/update.js', renderOptions);
      changed = true;
    }
    const remaining = plan(cart);
    if (remaining.add || Object.keys(remaining.updates).length) throw new Error('Gift did not reconcile');
    if (cart.items.some(item => giftIds.has(item.variant_id) && item.final_line_price !== 0)) throw new Error('Gift must remain free');
    if (changed && window.FoxTheme?.pubsub && cart.sections) {
      publishing = true;
      try {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart });
      } finally {
        publishing = false;
      }
    }
    document.getElementById('fe-guide-error')?.remove();
    return cart;
  }

  function sync() {
    const run = pending.catch(() => {}).then(reconcile);
    pending = run;
    return run;
  }

  function schedule() {
    if (publishing || scheduled) return;
    scheduled = true;
    queueMicrotask(() => {
      scheduled = false;
      sync().catch(showError);
    });
  }

  document.addEventListener('cart:updated', schedule);
  document.addEventListener('product-ajax:added', schedule);
  window.addEventListener('pageshow', schedule);

  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form === replayForm) return;
    const submitter = event.submitter;
    if (submitter?.name !== 'checkout' && !form.action.includes('/checkout')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkoutBusy) return;
    checkoutBusy = true;
    try {
      await sync();
      replayForm = form;
      form.requestSubmit(submitter || undefined);
    } catch { showError(); }
    finally { replayForm = null; checkoutBusy = false; }
  }, true);

  document.addEventListener('click', async event => {
    const buyNow = event.target.closest('[data-fe-guide-buy-now]');
    const checkoutLink = event.target.closest('a[href]');
    const isCheckoutLink = checkoutLink && new URL(checkoutLink.href, location.href).origin === location.origin && /\/checkout\/?$/.test(new URL(checkoutLink.href).pathname);
    if (!buyNow && !isCheckoutLink) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkoutBusy) return;
    checkoutBusy = true;
    if (buyNow) buyNow.disabled = true;
    try {
      if (buyNow) {
        const form = buyNow.closest('form');
        if (!form || !form.reportValidity()) return;
        const response = await fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(form), credentials: 'same-origin', signal: AbortSignal.timeout(15000) });
        if (!response.ok) throw new Error('Could not add product');
      }
      const cart = await sync();
      if (!cart.items.length) throw new Error('Empty cart');
      location.assign(isCheckoutLink ? checkoutLink.href : root + 'checkout');
    } catch { showError(); }
    finally { checkoutBusy = false; if (buyNow) buyNow.disabled = false; }
  }, true);

  window.feHormonalGift = { sync, plan };
  schedule();
})();

